const YoutubeShorts = {
  mounted() {
    this.handleClick = (e) => {
      let defaultDiv = this.el;
      if (this.el.querySelector("iframe")) return; // Iframe already loaded

      defaultDiv.classList.add("content-youtube-shorts");
      defaultDiv.classList.remove("content-image");
      defaultDiv.classList.remove("self-center");

      let videoId = defaultDiv.dataset.videoId;
      let playerOpts = JSON.parse(defaultDiv.dataset.playerOpts);
      let title = defaultDiv.dataset.title;
      let indetail = defaultDiv.dataset.indetail === "true";

      let iframe = document.createElement("iframe");
      iframe.src = this.buildYouTubeUrl(videoId, playerOpts);
      iframe.title = title;
      iframe.frameBorder = "0";
      iframe.allow =
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
      iframe.allowFullscreen = true;
      if (indetail) {
        iframe.classList.add("indetail");
      }

      // Replace the thumbnail with the iframe
      this.el.innerHTML = "";
      this.el.appendChild(iframe);
    };
    this.el.addEventListener("click", this.handleClick);
  },

  buildYouTubeUrl(videoId, playerOpts) {
    let baseUrl = `https://www.youtube-nocookie.com/embed/${videoId}`;
    let queryParams = new URLSearchParams(playerOpts).toString();
    return `${baseUrl}?${queryParams}`;
  },
  destroyed() {
    this.el.removeEventListener("click", this.handleClick);
  },
};
export default YoutubeShorts;
